<ng-container *ngIf="isDisplay">
  <ng-container *ngFor="let item of content">
    <div
      #alertErrorRef
      [ngClass]="['alert-' + role, customClassName]"
      class="idp-alert"
      role="alert"
      tabindex="-1"
    >
      <div class="idp-alert__body">
        <ng-container>
          <div class="idp-alert__body-fl">
            <i
              *ngIf="icon"
              [ngClass]="'idp-icon-' + role"
              aria-hidden="true"
            ></i>
          </div>
          <p
            *ngIf="item.text && item.text !== ''"
            class="idp-alert__body-content"
          >
            <span *ngIf="title" class="idp-alert-title">{{ title }}</span>
            <span [innerHTML]="item.text"></span>
            <a
              (click)="clicked($event)"
              *ngIf="item.linkText && item.linkText !== ''"
              [innerHTML]="item.linkText"
              class="idp-alert-link"
              href="javascript:void(0)"
            ></a>
          </p>
        </ng-container>
      </div>
    </div>
  </ng-container>
</ng-container>
